/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceType } from './SurfaceType';
import {
    SurfaceTypeFromJSON,
    SurfaceTypeFromJSONTyped,
    SurfaceTypeToJSON,
    SurfaceTypeToJSONTyped,
} from './SurfaceType';

/**
 * A typed pointer to a surface. Replaces the scalar surfaceId pattern.
 * @export
 * @interface HostRef
 */
export interface HostRef {
    /**
     * 
     * @type {SurfaceType}
     * @memberof HostRef
     */
    hostType: SurfaceType;
    /**
     * The surface's id. hostType decides which collection it belongs to.
     * @type {string}
     * @memberof HostRef
     */
    hostId: string;
}



/**
 * Check if a given object implements the HostRef interface.
 */
export function instanceOfHostRef(value: object): value is HostRef {
    if (!('hostType' in value) || value['hostType'] === undefined) return false;
    if (!('hostId' in value) || value['hostId'] === undefined) return false;
    return true;
}

export function HostRefFromJSON(json: any): HostRef {
    return HostRefFromJSONTyped(json, false);
}

export function HostRefFromJSONTyped(json: any, ignoreDiscriminator: boolean): HostRef {
    if (json == null) {
        return json;
    }
    return {
        
        'hostType': SurfaceTypeFromJSON(json['hostType']),
        'hostId': json['hostId'],
    };
}

export function HostRefToJSON(json: any): HostRef {
    return HostRefToJSONTyped(json, false);
}

export function HostRefToJSONTyped(value?: HostRef | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostType': SurfaceTypeToJSON(value['hostType']),
        'hostId': value['hostId'],
    };
}

